import styled from 'styled-components';

export const InsightHeaderStatus = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #787f88;
  text-transform: capitalize;
  transform: translateY(2px);
`;

export const InsightHeaderSlash = styled.span`
  padding: 0 8px;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #c1c3c6;
  transform: translateY(2px);
`;
